import { useEffect, useState } from "react";
import { History, Loader2 } from "lucide-react";
import { api, brl, fmtDateTime } from "@/lib/api";
import { cn } from "@/lib/utils";

const FIELD = { price: "Preço de venda", promo_price: "Preço promocional", cost: "Custo" };

function Change({ h }) {
  const up = h.old != null && h.new != null && h.new > h.old;
  const down = h.old != null && h.new != null && h.new < h.old;
  const pct = h.old ? ` (${up ? "+" : ""}${(((h.new - h.old) / h.old) * 100).toFixed(1).replace(".", ",")}%)` : "";
  return (
    <span className={cn("font-mono text-sm", up && "text-red-500", down && "text-emerald-600 dark:text-emerald-400")}>
      {h.old == null ? "—" : brl(h.old)} → {h.new == null ? "sem valor" : brl(h.new)}{h.old && h.new != null ? pct : ""}
    </span>
  );
}

export function PriceHistoryTab({ productId }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/products/${productId}/price-history`).then((r) => setRows(r.data)).catch(() => setRows([])); }, [productId]);
  if (!rows) return <div className="grid place-items-center py-10"><Loader2 className="h-5 w-5 animate-spin text-primary" /></div>;
  if (!rows.length) return <p className="flex items-center gap-2 py-8 text-sm text-muted-foreground" data-testid="price-history-empty"><History className="h-4 w-4" />Nenhuma mudança de preço ou custo registrada ainda.</p>;
  return (
    <div className="divide-y rounded-lg border" data-testid="price-history-list">
      {rows.map((h) => (
        <div key={h.id} className="flex flex-wrap items-center justify-between gap-2 px-3 py-2.5" data-testid={`price-history-${h.id}`}>
          <div className="min-w-0"><p className="text-sm font-medium">{FIELD[h.field] || h.field}</p>
            <p className="text-xs text-muted-foreground">{fmtDateTime(h.created_at)} · {h.user} · {h.source}</p></div>
          <Change h={h} />
        </div>
      ))}
    </div>
  );
}
